module.exports = __webpack_public_path__ + "static/media/sc_38_i.044109ef.png";